import fetchRate from './fetchRate';
import fetchQuotesHttpClient, { fetchV3Quotes } from './quotes/fetchQuotes';
import transformQuotesResponse from './quotes/transformQuotesResponse';

function fetchQuotes(
  sourceCurrency,
  targetCurrency,
  amount,
  midMarketRate,
  wiseFee,
  {
    sourceCountry,
    providerCountry,
    filter,
    includeWise,
    numberOfProviders,
    useV3ComparisonApi = false,
  } = {},
  providerTypes = undefined,
) {
  return useV3ComparisonApi
    ? fetchV3Quotes(
        sourceCurrency,
        targetCurrency,
        amount,
        midMarketRate,
        wiseFee,
        {
          providerCountry,
          sourceCountry,
        },
        providerTypes,
      ).then((quotes) => transformQuotesResponse(quotes, targetCurrency))
    : fetchQuotesHttpClient(
        sourceCurrency,
        targetCurrency,
        amount,
        midMarketRate,
        wiseFee,
        {
          providerCountry,
          sourceCountry,
          filter,
          includeWise,
          numberOfProviders,
        },
        providerTypes,
      ).then((quotes) => transformQuotesResponse(quotes, targetCurrency));
}

export { fetchRate, fetchQuotes };
